export default __webpack_public_path__ + "static/media/goshen26.d99872fe.jpg";